import React, {
  useState, useEffect,
} from 'react';
import {
  Layout, Menu, Drawer,
} from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import Icon, {
  CloseOutlined,
} from '@ant-design/icons';
import {
  HeaderLogo, HeaderLogoBox,
} from './HeaderStyles';
import logo from '../../../common/images/logo.png';
import navItemsList, { filterByAdminType, filterByRole } from './navItemsList';
import getLinks from '../../../logic/utils/getLinks';
import 'antd/dist/antd.css';

function SideNavigation(props) {
  const { drawerVisible, setDrawerVisible } = props;
  const [selected, setSelected] = useState();
  const [isMobile, setIsMobile] = useState(false);
  const [adminType, setAdminType] = useState('');
  const navigate = useNavigate();
  const arrLink = getLinks();
  const role = window.localStorage.getItem('role');

  const setClick = (option) => {
    setSelected(option.key);
    if (isMobile) {
      setDrawerVisible(false);
    }
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1350);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    fetch('/api/admin-config')
      .then((res) => res.json())
      .then((data) => {
        if (data.adminType) setAdminType(data.adminType);
      })
      .catch(() => { });
  }, []);

  const filteredNavItems = filterByRole(filterByAdminType(navItemsList, adminType), role);

  const renderMenuItems = () => (
    filteredNavItems
      .filter((item) => (arrLink.some((el) => el === item.link)))
      .map((item) => (item.subItems.length
        ? (
          <Menu.SubMenu
            key={item.key}
            title={(
              <Link to={item.link}>
                <Icon component={item.icon} />
                <span className="nav-text">{item.text}</span>
              </Link>
            )}
            onTitleClick={() => {
              setSelected(item.subItems[0].link);
            }}
          >
            {item.subItems.map((subItem) => (
              <Menu.Item key={subItem.key} onClick={setClick}>
                <Link to={subItem.link}>
                  <Icon component={subItem.icon} />
                  <span className="nav-text">{subItem.text}</span>
                </Link>
              </Menu.Item>
            ))}
          </Menu.SubMenu>
        )
        : (
          <Menu.Item key={item.key} onClick={setClick}>
            <Link to={item.link}>
              <Icon component={item.icon} />
              <span className="nav-text">{item.text}</span>
            </Link>
          </Menu.Item>
        )))
  );

  if (role === 'eq_controller') {
    return null;
  }

  if (isMobile) {
    return (
      <Drawer
        title={(
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <HeaderLogo
              onClick={() => {
                navigate('/monitoring/');
                setDrawerVisible(false);
              }}
              src={logo}
              style={{ maxHeight: '36px' }}
            />
          </div>
        )}
        placement="left"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={320}
        bodyStyle={{ padding: 0 }}
        headerStyle={{
          padding: '16px 24px',
          minHeight: '64px',
        }}
        closeIcon={<CloseOutlined style={{ fontSize: '16px' }} />}
      >
        <Menu mode="inline" theme="light" selectedKeys={[selected]}>
          {renderMenuItems()}
        </Menu>
      </Drawer>
    );
  }

  return (
    <Layout.Sider theme="light" width={250}>
      <HeaderLogoBox>
        <HeaderLogo
          onClick={() => { navigate('/monitoring/'); }}
          src={logo}
          style={{ maxHeight: '36px' }}
        />
      </HeaderLogoBox>
      <Menu mode="inline" theme="light" selectedKeys={[selected]}>
        {renderMenuItems()}
      </Menu>
    </Layout.Sider>
  );
}

export default SideNavigation;
